export { F as FetchManager, a as SaveOp, b as Snapshot, S as SnapshotRecordArray } from "./fetch-manager-025964e9";